module.exports = __webpack_public_path__ + "static/media/lo5d_post_A.64d3c585.png";